import {Component, OnInit} from '@angular/core';
import {UtButtonComponent, UtIconComponent, type UtIconName} from '../../ui';

@Component({
  selector: 'app-video-meeting-mockup',
  templateUrl: './video-meeting-mockup.component.html',
  styleUrls: ['./video-meeting-mockup.component.scss'],
  imports: [UtButtonComponent, UtIconComponent],
})
export class VideoMeetingMockupComponent implements OnInit {
  videoParticipants = [...Array(6).keys()].map(
    (i) => `/assets/img/mockup/video-participant-${i + 1}.jpg`,
  );
  remoteEnabled = false;
  media = 'camera';
  // TODO icon: review videocam/slideshow — using closest matches from ut-icon registry
  mediaIcon: UtIconName = 'video';

  constructor() {}

  ngOnInit(): void {}

  remoteToggle(): void {
    this.remoteEnabled = !this.remoteEnabled;
  }

  mediaSwitchToggle(): void {
    this.media = this.media === 'camera' ? 'content' : 'camera';
    // TODO icon: review slideshow — using 'play' as closest match
    this.mediaIcon = this.media === 'camera' ? 'play' : 'video';
  }

  get contentEnabled(): boolean {
    return this.media === 'content';
  }

  get cameraEnabled(): boolean {
    return this.media === 'camera';
  }
}
